<template>
  <div
    :class="{ 'activity-progress-bar': true, 'has-activity-instructions': activityHasInstructions }"
    aria-label="activities completed"
    role="progressbar"
    :aria-valuemax="totalActivities"
    :aria-valuenow="currentActivity"
  >
    <div
      class="activity-progress-bar-background"
      :style="{ width: `${progressPercentage}%` }"
    ></div>
    <div
      :class="{
        'activity-progress-bar-content': true,
        'has-activity-instructions': activityHasInstructions
      }"
    >
      {{ currentActivity }} of {{ totalActivities }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activityHasInstructions: Boolean,
    currentActivity: Number,
    totalActivities: Number
  },
  computed: {
    progressPercentage() {
      return (this.currentActivity / this.totalActivities) * 100;
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-progress-bar {
  // height is set by .activity-progress-bar-container in App.vue
  border: 1px solid black;
  text-align: center;
  width: 100%;
}

.activity-progress-bar-background {
  animation: 1s linear infinite progress-bar-stripes;
  background-color: #48d1cc;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 16px 16px;
  height: 100%;
}

.activity-progress-bar-content {
  align-items: center;
  font-weight: 600;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 2px;
  width: 100%;
}

.has-activity-instructions {
  @media (max-width: 1100px) {
    margin-top: 10px;
  }
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
</style>
